<template>
   <div>
    <add-new-bl-record @RecordAdded="refreshBList()"></add-new-bl-record>
    <vue-good-table
            ref="BlackListTable"
            :columns="BL_Table_Columns"
            :rows="BL_Table_Rows"
            class="vgt-table bordered condensed e-table-1 e-dynamic-filter e-ts-12"
            :search-options="{enabled: true, placeholder: 'ძებნის პარამეტრი'}"
            :sort-options="{enabled: true, initialSortBy: {field: 'id', type: 'desc'}}"
            :row-style-class="rowStyleClassFn"
            @on-row-click="RR_Table_RowClick"
            :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 5,
                                    position: 'top',
                                    perPageDropdown: [10, 15, 25, 50],
                                    dropdownAllowAll: false,
                                    setCurrentPage: 1,
                                    nextLabel: 'შემდეგი',
                                    prevLabel: 'წინა',
                                    rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
                                    ofLabel: '-ჩანაწერი სულ',
                                    pageLabel: 'გვერდი', // for 'pages' mode
                                    allLabel: 'ყველა',
                                  }"
          >
          <div slot="table-actions">
              <!-- <button class="btn btn-link e-mtavr-17 btn-outline-secondary" @click="filterToggle()">
                <i class="lnr lnr-funnel mr-2"></i> ფილტრები
              </button> -->
              <!-- <button class="btn btn-link e-mtavr-17 btn-outline-secondary" v-b-modal.excelImportModal>
                <i class="lnr lnr-download mr-2"></i> ექსელიდან იმპორტი
              </button> -->
              <!-- <b-button v-b-modal.addRequestModal>Show Modal</b-button> -->
              <!-- <button class="btn btn-link e-mtavr-17 btn-outline-secondary" @click="exportToExcel()">
                <i class="lnr lnr-upload mr-2"></i> ექსელში ექსპორტი
              </button> -->
              <!-- <download-excel class="btn btn-link e-mtavr-17 btn-outline-purple"
    :data   = "json_data">
   <i class="fas fa-file-export mr-2"></i> ექსელში ექსპორტი
              </download-excel>-->
              <b-button
                class="btn btn-link e-mtavr-17 btn-outline-secondary mr-2"
                v-b-modal.addNewBLRecord
              >
                <i class="lnr lnr-file-add mr-2"></i> ახალი ჩანაწერი
              </b-button>
            </div>
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'statusDesc'">
                <div
                  v-if="!props.row.status"
                  class="badge badge-danger e-nusx-8"
                >არააქტიური</div>
                <div v-else class="badge badge-success e-nusx-8">აქტიური</div>
            </div>
            <div v-else-if="props.column.field == 'functions'" class="text-left">
                <button v-if="!props.row.status" type="button" class="btn btn-outline-success btn-xs icon-btn borderless" @click="changeStatus(props.row)"><span class="lnr lnr-checkmark-circle"></span></button>
                <button v-else type="button" class="btn btn-outline-danger btn-xs icon-btn borderless" @click="changeStatus(props.row)"><span class="lnr lnr-cross-circle"></span></button>
              </div>
          </template>
          </vue-good-table>
          <add-comment :blRecord="blRecord" @statusChanged="refreshBList()"></add-comment>
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import addNewBlRecord from '../components/addNewBLRecord'
import moment from 'moment'
import XLSX from 'xlsx'
import AddComment from '../components/addComment.vue'
export default {
  name: 'Black_List_v1',
  metaInfo: {
    title: ' - შავი სია'
  },
  components: {
    addNewBlRecord,
    AddComment
  },
  data () {
    return {
      blRecord: {},
      BL_Table_Columns: [
        {
          label: '#',
          type: 'number',
          thClass: 'e-ts-12',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'იურიდიული სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'juridicalStatusDesc'
        },
        {
          label: 'სრული სახელი / დასახელება',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'firstName'
        },
        // {
        //   label: 'გვარი',
        //   type: 'text',
        //   thClass: 'e-mtavr-17 e-ts-12',
        //   tdClass: 'e-ts-12',
        //   field: 'lastName'
        // },
        {
          label: 'პირადი ნომერი / პირ. მოწმობის ნომერი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'identificator'
        },
        {
          label: 'დაბადების თარიღი',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'birthDate'
        },
        {
          label: 'სიაში დამატების თარიღი',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'recDate'
        },
        {
          label: 'ქმედების ავტორი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'statusChangeUserName'
        },
        {
          label: 'სტატუსის ცვლილების თარიღი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'statusChangeDate'
        },
        {
          label: 'კომენტარი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'comment'
        },
        {
          label: 'სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'statusDesc'
        },
        {
          label: 'ფუნქციები',
          field: 'functions',
          tdClass: 'e-ts-12',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-08rem'
        }
      ],
      BL_Table_Rows: []
    }
  },
  beforeCreate () {
    const GETRequestHeaders = {
      headers: {
        accept: 'text/plain',
        Authorization: ''
      }
    }

    GETRequestHeaders.headers.Authorization = 'Bearer ' + this.$store.getters.getAccessToken
    BaseService.GetBlackList(GETRequestHeaders)
      .then(res => {
        console.log(res)
        for (var i = 0, len = res.data.result.length; i < len; i++) {
          res.data.result[i].identificator = res.data.result[i].personalN ? res.data.result[i].personalN : res.data.result[i].documentNumber
          if (res.data.result[i].recDate === null || res.data.result[i].recDate === '') {
            res.data.result[i].recDate = 'თარიღი ცარიელია'
          } else {
            res.data.result[i].recDate = moment(res.data.result[i].recDate).format('DD.MM.YYYY HH:mm:SS')
          }
          if (res.data.result[i].birthDate === null || res.data.result[i].birthDate === '') {
            res.data.result[i].birthDate = 'თარიღი ცარიელია'
          } else {
            res.data.result[i].birthDate = moment(res.data.result[i].birthDate).format('DD.MM.YYYY')
          } if (res.data.result[i].statusChangeDate === null || res.data.result[i].statusChangeDate === '') {
            res.data.result[i].statusChangeDate = 'თარიღი ცარიელია'
          } else {
            res.data.result[i].statusChangeDate = moment(res.data.result[i].statusChangeDate).format('DD.MM.YYYY  HH:mm:SS')
          }
        }
        this.BL_Table_Rows = res.data.result
      })
  },
  methods: {
    exportToExcel () {
      const sheetData = []
      var data = this.$refs.BlackListTable.filteredRows[0].children
      data.map(res => {
        sheetData.push({
          'იურიდიული სტატუსი': res.juridicalStatusDesc,
          სახელი: res.firstName,
          გვარი: res.lastName,
          'პირადი ნომერი/ პირ. მოწმობის ნომერი': res.personalN,
          'დაბადების თარიღი': res.birthDate,
          'სიაში დამატების თარიღი': res.recDate,
          'ქმედების ავტორი': res.statusChangeUserName,
          'სტატუსის ცვლილების თარიღი': res.statusChangeDate,
          კომენტარი: res.comment,
          სტატუსი: res.status ? 'აქტიური' : 'არააქტიური'
        })
      })
      var newWB = XLSX.utils.book_new()
      var newWS = XLSX.utils.json_to_sheet(sheetData)
      XLSX.utils.book_append_sheet(newWB, newWS, 'Data')
      XLSX.writeFile(newWB, 'BLExport-' + moment(Date.now()).format('DD.MM.YYYY') + '.xlsx')
    },
    refreshBList () {
      const GETRequestHeaders = {
        headers: {
          accept: 'text/plain',
          Authorization: ''
        }
      }

      GETRequestHeaders.headers.Authorization = 'Bearer ' + this.$store.getters.getAccessToken
      BaseService.GetBlackList(GETRequestHeaders)
        .then(res => {
          console.log(res)
          for (var i = 0, len = res.data.result.length; i < len; i++) {
            res.data.result[i].identificator = res.data.result[i].personalN ? res.data.result[i].personalN : res.data.result[i].documentNumber
            if (res.data.result[i].recDate === null || res.data.result[i].recDate === '') {
              res.data.result[i].recDate = 'თარიღი ცარიელია'
            } else {
              res.data.result[i].recDate = moment(res.data.result[i].recDate).format('DD.MM.YYYY HH:mm:SS')
            }
            if (res.data.result[i].birthDate === null || res.data.result[i].birthDate === '') {
              res.data.result[i].birthDate = 'თარიღი ცარიელია'
            } else {
              res.data.result[i].birthDate = moment(res.data.result[i].birthDate).format('DD.MM.YYYY')
            } if (res.data.result[i].statusChangeDate === null || res.data.result[i].statusChangeDate === '') {
              res.data.result[i].statusChangeDate = 'თარიღი ცარიელია'
            } else {
              res.data.result[i].statusChangeDate = moment(res.data.result[i].statusChangeDate).format('DD.MM.YYYY  HH:mm:SS')
            }
          }
          this.BL_Table_Rows = res.data.result
        })
    },
    changeStatus (data) {
      // debugger // eslint-disable-line
      this.blRecord = data
      const HeaderParams = {
        headers: {
          accept: 'text/plain',
          Authorization: ''
        }
      }
      HeaderParams.headers.Authorization = 'Bearer ' + this.$store.getters.getAccessToken
      this.$bvModal.show('addComment')

    //   BaseService.ChangeBlackListStatus(HeaderParams, data.id, data.status ? 1 : 0)
    //     .then(res => {
    //       if (res.data.success) {
    //         this.refreshBList()
    //       }
    //     })
    },
    RR_Table_RowClick () {},
    rowStyleClassFn () {}
  }
}
</script>
